import React from "react";
import { Grid } from "@mui/material";
import { MASK_TYPE, Box, Typography, TextField } from "@curves/ui-base";
import { PasswordToggle, EmployeeSelect } from "@icoach/components/";
import { employeeOption } from "@icoach/development/development.config";

const ComponentTestPage = props => {
	return (
		<Box className="main-container-spacing">
			<Grid container spacing={2}>
				<Grid item xs={6}>
					<EmployeeSelect options={employeeOption} fullWidth />
				</Grid>
			</Grid>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<Typography variant="h3">TextField</Typography>
				</Grid>
				<Grid item xs={6}>
					<TextField label="身份證" maskType={MASK_TYPE.IDCARD} fullWidth />
				</Grid>
				<Grid item xs={6}>
					<TextField label="信用卡卡號" maskType={MASK_TYPE.CCN} fullWidth />
				</Grid>
				<Grid item xs={6}>
					<TextField label="信用卡有效日期" maskType={MASK_TYPE.CVV2} fullWidth />
				</Grid>
				<Grid item xs={6}>
					<TextField label="手機" maskType={MASK_TYPE.MOB} fullWidth />
				</Grid>
				<Grid item xs={6}>
					<TextField label="自然人號碼" maskType={MASK_TYPE.CDC} fullWidth />
				</Grid>
				<Grid item xs={6}>
					<TextField label="手機載具" maskType={MASK_TYPE.MB} fullWidth />
				</Grid>
				<Grid item xs={6}>
					<TextField label="公司統一編號" maskType={MASK_TYPE.TID} fullWidth />
				</Grid>
				<Grid item xs={6}>
					<TextField label="愛心碼" maskType={MASK_TYPE.DC} fullWidth />
				</Grid>
				<Grid item xs={6}>
					<TextField label="電話號碼-分機" maskType={MASK_TYPE.TEL} fullWidth />
				</Grid>
				<Grid item xs={6}>
					<TextField label="正負整數" maskType={MASK_TYPE.PLUS_MINUS} fullWidth />
				</Grid>
				<Grid item xs={6}>
					<TextField label="正整數" maskType={MASK_TYPE.POSITIVE_INT} placeholder="這是正整數，有預設也可以額外填寫placeholder" fullWidth />
				</Grid>
				<Grid item xs={6}>
					<TextField label="一般數字" maskType={MASK_TYPE.DECIMAL} fullWidth />
				</Grid>
                <Grid item xs={6}>
					<TextField label="金錢" maskType={MASK_TYPE.MONEY} fullWidth />
				</Grid>
				<Grid item xs={6}>
					<TextField label="電子信箱" maskType={MASK_TYPE.EMAIL} fullWidth />
				</Grid>
				<Grid item xs={6}>
					<PasswordToggle />
				</Grid>
			</Grid>
		</Box>
	);
};

export default ComponentTestPage;
